module.exports = __webpack_public_path__ + "img/白附子.f898ce05.jpg";